import { safeJoin } from './string-utils';

export const getFullName = (firstName: string | null | undefined, lastName: string | null | undefined) => {
    return safeJoin([firstName, lastName], ' ');
};
